import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  toggleActiveContestPopUp,
  setActiveContestPopUp,
  setSignupFlow,
  setContestStep,
  toggleActiveAuthPopUp,
  submitContest,
  fetchContestItems,
  showActiveContestPopUp,
  clearSubmissionError
} from '../../actions/contest';
import Cookies from 'js-cookie';

import { getLaunchVoteItem } from '../../js/utility';

import { productClickGA } from '../../js/analytics';

import { withTranslation } from 'react-i18next';

import iconLocation from '../../images/icons/icon_32_location.png';
import iconDuration from '../../images/icons/icon_32_duration.png';
import iconPax from '../../images/icons/icon_32_noofpax.png';
import iconBYOC from '../../images/icons/icon_fordvehicle_yellow.png';
import iconLeft from '../../images/icons/icon_72_leftchev.png';
import iconRight from '../../images/icons/icon_72_rightchev.png';
import iconClose from '../../images/icons/icon_32_close.png';
import closeIcon from '../../images/icons/icon_close_black.svg';

class VoteItemPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      activeId: 0,
      slogan: '',
      sloganError: false
    };
    this.popupRef = React.createRef();
    this.changePopup = this.changePopup.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleSubmissionOnChange = this.handleSubmissionOnChange.bind(this);
    this.handleOnVote = this.handleOnVote.bind(this);
    this.handleOnPostVote = this.handleOnPostVote.bind(this);
    this.handleOnSubmission = this.handleOnSubmission.bind(this);
    this.handleDismissPopup = this.handleDismissPopup.bind(this);
    this.handleOnSubmissionCompleted = this.handleOnSubmissionCompleted.bind(
      this
    );
  }

  componentDidMount() {
    const { activeContestId, contestItems } = this.props;
    if (activeContestId && contestItems) {
      const item = getLaunchVoteItem(activeContestId, contestItems);
      this.setState({
        item: item,
        activeId: item.id
      });
    }
  }

  componentDidUpdate() {
    const {
      hasSubmitted,
      setContestStep,
      step,
      clearSubmissionError
    } = this.props;
    if (this.popupRef) {
      this.popupRef.current.focus();
    }
    if (hasSubmitted) {
      setContestStep('done');
    }
    if (step === 'voted') {
      clearSubmissionError();
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  changePopup(amount) {
    const { contestItems } = this.props;
    const { activeId } = this.state;

    const currIndex = contestItems.findIndex(vote => {
      return vote.id == activeId;
    });

    const maxTrips = contestItems.length;
    if (
      (currIndex >= maxTrips - 1 && amount > 0) ||
      (currIndex === 0 && amount < 0)
    ) {
      return;
    }
    let newId = contestItems[currIndex + amount].id;
    const item = getLaunchVoteItem(newId, contestItems);
    this.setState({
      item: item,
      activeId: newId
    });
  }

  handleKeyPress(e) {
    if (e.key === 'ArrowLeft') {
      this.changePopup(-1);
    } else if (e.key === 'ArrowRight') {
      this.changePopup(1);
    }
  }

  handleSubmissionOnChange(event) {
    this.setState({
      slogan: event.target.value
    });
  }

  // Click on 'vote' button during 'voting' step
  handleOnVote() {
    const {
      signedIn,
      setSignupFlow,
      toggleActiveAuthPopUp,
      toggleActiveContestPopUp,
      setContestStep
    } = this.props;

    if (!signedIn) {
      // If not signed in, open auth popup and dismiss contest popup
      setSignupFlow('signup');
      toggleActiveAuthPopUp(true);
      toggleActiveContestPopUp(false);
    } else {
      // If signed in, step 'voted'
      setContestStep('voted');
    }
  }

  // Click on 'you're almost done' button during 'voting' step
  handleOnPostVote() {
    const { setContestStep } = this.props;
    setContestStep('submission');
  }

  // Click on 'complete submission' button during 'submission' step
  handleOnSubmission() {
    const { slogan, sloganError } = this.state;
    const { activeContestId, submitContest, clearSubmissionError } = this.props;

    clearSubmissionError();

    if (slogan.length !== 0 && !sloganError) {
      const data = {
        trip_id: activeContestId,
        answer: slogan
      };
      submitContest(data, decodeURIComponent(Cookies.get('XSRF-TOKEN')));
    }
  }
  // Click on 'done' button during 'submission complete' step
  handleOnSubmissionCompleted() {
    const {
      toggleActiveContestPopUp,
      setContestStep,
      fetchContestItems,
      showActiveContestPopUp
    } = this.props;
    showActiveContestPopUp(null, false);
    setContestStep('voting');
    fetchContestItems();
  }

  handleDismissPopup() {
    const { showActiveContestPopUp, setContestStep } = this.props;
    showActiveContestPopUp(null, false);
    setContestStep('voting'); // reset back popup
    document.body.style.overflow = 'auto';
  }

  render() {
    const {
      toggleActiveContestPopUp,
      contestItems,
      signedIn,
      signupFlow,
      setContestStep,
      activeContestId,
      step,
      setSignupFlow,
      submissionError,
      clearSubmissionError
    } = this.props;
    const { item, activeId, slogan, sloganError } = this.state;

    const currentIndex = contestItems.findIndex(trip => trip.id === activeId);

    const percentage = item.result_vote;
    let value = 0;
    if (percentage) {
      if (Number.isInteger(percentage)) {
        value = percentage;
      } else {
        value = percentage.toFixed(0);
      }
    }

    // Voting
    if (Object.keys(item).length !== 0 && step === 'voting') {
      return (
        <>
          <div
            className='fe-overlay'
            onClick={() => this.handleDismissPopup()}
          />

          <div
            className='fe-contest-popup-container'
            onKeyDown={this.handleKeyPress}
            ref={this.popupRef}
            tabIndex='0'
          >
            <div className='fe-close'>
              <div
                onClick={() => this.handleDismissPopup()}
                style={{ cursor: 'pointer' }}
              >
                <img src={closeIcon} alt='' />
              </div>
            </div>
            <div className='fe-contest-popup-details'>
              <div className='img-container'>
                {item.images.carousel.map((img, index) => {
                  if (index < 3)
                    return (
                      <img
                        src={img.image_url}
                        className='img'
                        alt=''
                        key={img.id}
                      />
                    );
                })}
              </div>

              <h2 className='title'>{item.title}</h2>
              <div
                className='desc'
                dangerouslySetInnerHTML={{
                  __html: item.description
                }}
              />
              <div
                style={{ cursor: 'pointer' }}
                className='fe-u-btnlink'
                onClick={() => this.handleOnVote()}
              >
                Vote
              </div>
            </div>

            {currentIndex > 0 ? (
              <div
                onClick={() => this.changePopup(-1)}
                className='fe-trip-arrow left'
              >
                <img src={iconLeft} alt='' />
              </div>
            ) : null}
            {currentIndex + 1 < contestItems.length ? (
              <div
                onClick={() => this.changePopup(1)}
                className='fe-trip-arrow right'
              >
                <img src={iconRight} alt='' />
              </div>
            ) : null}
          </div>
        </>
      );
    }

    // Post vote
    else if (Object.keys(item).length !== 0 && step === 'voted' && signedIn) {
      //console.log("test");
      return (
        <>
          <div
            className='fe-overlay'
            onClick={() => this.handleDismissPopup()}
          />
          <div
            className='fe-contest-popup-container'
            ref={this.popupRef}
            tabIndex='0'
          >
            <div className='fe-close'>
              <div
                onClick={() => this.handleDismissPopup()}
                style={{ cursor: 'pointer' }}
              >
                <img src={closeIcon} alt='' />
              </div>
            </div>
            <div className='fe-contest-popup-details'>
              {/* {console.log(item)} */}
              <div className='img-container'>
                {item.images.carousel.map((img, index) => {
                  if (index < 3)
                    return (
                      <img
                        src={img.image_url}
                        className='img'
                        alt=''
                        key={img.id}
                      />
                    );
                })}
              </div>

              <h2 className='title voted'>{item.title}</h2>
              <h2 className='title'>Thank you for your vote!</h2>

              <div className='preferred-square'>
                <h2 className='title preferred'>
                  This experience is preferred by
                </h2>
                <div className='content'>
                  <h2 className='title bigger'>{value}%</h2>
                  <h2 className='title left'>
                    of like minded <br /> adventurers
                  </h2>
                </div>
              </div>

              <div
                style={{ cursor: 'pointer' }}
                className='fe-u-btnlink'
                onClick={() => this.handleOnPostVote()}
              >
                You're almost done
              </div>
            </div>
          </div>
        </>
      );
    }

    // Slogan submission
    else if (
      Object.keys(item).length !== 0 &&
      step === 'submission' &&
      signedIn
    ) {
      return (
        <>
          <div
            className='fe-overlay'
            onClick={() => this.handleDismissPopup()}
          />
          <div
            className='fe-contest-popup-container'
            // ref={this.popupRef}
            tabIndex='0'
          >
            <div className='fe-close'>
              <div
                onClick={() => this.handleDismissPopup()}
                style={{ cursor: 'pointer' }}
              >
                <img src={closeIcon} alt='' />
              </div>
            </div>
            <div className='fe-contest-popup-details'>
              <h2 className='title'>
                Tell us what does a 'getaway' mean to you?
              </h2>

              <div className='slogan-area'>
                <textarea
                  ref={this.popupRef}
                  name='slogan'
                  id='slogan'
                  cols='30'
                  rows='10'
                  className='slogan-area'
                  value={slogan}
                  onChange={this.handleSubmissionOnChange}
                  maxLength='150'
                />
                <span className='length'>({slogan.length})</span>
              </div>

              <div className='slogan-guidelines'>
                Guidelines
                <ul>
                  <li>English, Bahasa Malaysia, and Mandarin are allowed.</li>
                  <li>Must be 150 characters or less.</li>
                </ul>
              </div>

              {submissionError && (
                <span style={{ marginBottom: 10, color: 'red' }}>
                  {submissionError}
                </span>
              )}

              <div
                style={{
                  cursor: `${slogan === '' ? 'not-allowed' : 'pointer'}`
                }}
                className={`fe-u-btnlink ${slogan === '' && 'disabled'}`}
                onClick={() => this.handleOnSubmission()}
              >
                Complete Submission
              </div>
            </div>
          </div>
        </>
      );
    }

    // Already voted
    else if (
      Object.keys(item).length !== 0 &&
      step === 'alreadyVoted' &&
      signedIn
    ) {
      clearSubmissionError();

      return (
        <>
          <div
            className='fe-overlay'
            onClick={() => this.handleDismissPopup()}
          />
          <div
            className='fe-contest-popup-container'
            ref={this.popupRef}
            tabIndex='0'
          >
            <div className='fe-close'>
              <div
                onClick={() => this.handleDismissPopup()}
                style={{ cursor: 'pointer' }}
              >
                <img src={closeIcon} alt='' />
              </div>
            </div>
            <div className='fe-contest-popup-details'>
              <h2 className='title'>
                You've already voted!
                <br /> Please click OK to view the result.
                <br />
              </h2>

              <div
                style={{ cursor: 'pointer' }}
                className='fe-u-btnlink'
                onClick={() => this.handleDismissPopup()}
              >
                OK
              </div>
            </div>
          </div>
        </>
      );
    }

    // Done
    else {
      return (
        <>
          <div
            className='fe-overlay'
            onClick={() => this.handleOnSubmissionCompleted()}
          />
          <div
            className='fe-contest-popup-container'
            ref={this.popupRef}
            tabIndex='0'
          >
            <div className='fe-close'>
              <div
                onClick={() => this.handleOnSubmissionCompleted()}
                style={{ cursor: 'pointer' }}
              >
                <img src={closeIcon} alt='' />
              </div>
            </div>
            <div className='fe-contest-popup-details'>
              <div className='done-section'>
                <h2 className='title big'>Submission Complete!</h2>
                <p className='title small'>
                  We are processing your submission and a confirmation email
                  will be sent to you soon.
                  <br />
                  <br />
                  Winners will be announced via email and Facebook, so stay
                  tuned!
                  <br />
                  <br />
                </p>
              </div>
              <div
                style={{
                  cursor: 'pointer'
                }}
                className='fe-u-btnlink'
                onClick={() => this.handleOnSubmissionCompleted()}
              >
                Done
              </div>
            </div>
          </div>
        </>
      );
    }
  }
}

VoteItemPopup.propTypes = {
  trips: PropTypes.array,
  contestItems: PropTypes.array,
  activeContestId: PropTypes.number,
  setActiveContestPopUp: PropTypes.func.isRequired,
  toggleActiveContestPopUp: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  step: PropTypes.string.isRequired
};

const mapStateToProps = ({ contestState, authState }) => ({
  activeContestId: contestState.activeContestId,
  contestItems: contestState.contestItems,
  signupFlow: contestState.signupFlow,
  signedIn: authState.signedIn,
  step: contestState.step,
  authError: contestState.authError,
  hasSubmitted: contestState.hasSubmitted,
  submissionError: contestState.submissionError
});

const mapDispatchToProps = {
  setActiveContestPopUp,
  toggleActiveContestPopUp,
  toggleActiveAuthPopUp,
  setSignupFlow,
  setContestStep,
  submitContest,
  fetchContestItems,
  showActiveContestPopUp,
  clearSubmissionError
};

export default withTranslation()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(VoteItemPopup)
);
